import {
  DesktopVoucherBadge,
  MWebVoucherBadge
} from "../src/features/housing-affordability-voucher-badge";
import exportComponentsToRails from "../src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("voucherBadge", {
  DesktopVoucherBadge,
  MWebVoucherBadge
});
